import { Row, Col, ListGroup } from 'react-bootstrap'
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectCoverflow, Pagination, Navigation, Autoplay } from 'swiper/modules';

import { CheckCircle2 } from 'lucide-react'

import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

const CoverflowCarousel = ({ service }) => {

    return (
        <div className="py-4 bg-transparent">
            <Swiper
                effect={'coverflow'}
                grabCursor={true}
                centeredSlides={true}
                slidesPerView={'auto'}
                //loop={true}
                coverflowEffect={{
                    rotate: 15,
                    stretch: -50,
                    depth: 500,
                    modifier: 2.5,
                    slideShadows: false,
                }}
                autoplay={{
                    delay: 5000,
                    disableOnInteraction: true,
                }}
                navigation={true}
                pagination={{ clickable: true }}
                modules={[EffectCoverflow, Pagination, Navigation, Autoplay]}
                className="mySwiper"
            >
                {service.map((item, index) => (
                    <SwiperSlide key={index} className='card-custom'>
                        <div className="coverflow-card">
                            <img src={item.img} alt={item.title} className="w-100" />
                            <div className='p-4 mb-3'>
                                <div className="card-label pt-1">
                                    <h6 className="fw-bold mb-2 text-uppercase modal-service-subTitle" style={{ color: '#1b337e', letterSpacing: '1px' }}>
                                        {item.title}
                                    </h6>
                                </div>

                                {/*<p className="mb-4">{item.description}</p>*/}

                                <h6 className="fw-bold mb-3 text-uppercase" style={{ letterSpacing: '1px' }}>
                                    Actividades principales:
                                </h6>

                                <div className="multi-column-wrapper">
                                    {item.list.map((task, i) => (
                                        <div key={i} className="column-item">
                                            <CheckCircle2
                                                size={18}
                                                className="me-2 mt-1 flex-shrink-0"
                                                color="#1b337e"
                                            />
                                            <span className="text-dark" style={{ fontSize: '0.95rem', lineHeight: '1.4' }}>
                                                {task}
                                            </span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
};

export default CoverflowCarousel;